export const ROUTES = {
    Home: 'Home',
    About: 'About',
    Help: 'Help',
    Error404: 'Error404',
    BreathListView: 'BreathListView',
    BreathDonutView: 'BreathDonutView',
    CycleListView: 'CycleListView',
}